/* tp-rekenhulp-hal.js: rekenhulp toepassingspagina hal (Orbital LED). Logica v4 uit ontwerp 22-10-2026. */
(function () {
  'use strict';

  if (!window.tpTrack) {
    window.tpTrack = function (ev, data) {
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev };
      if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) o[k] = data[k]; } }
      window.dataLayer.push(o);
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-tp-event]') : null;
      if (!a) return;
      window.tpTrack(a.getAttribute('data-tp-event'), {
        tp_plek: a.getAttribute('data-tp-plek') || '',
        tp_pagina: location.pathname
      });
    });
  }

  function intOf(v) { var s = String(v == null ? '' : v).replace(/[^\d]/g, ''); return s ? parseInt(s, 10) : 0; }
  function dec(v) { return parseFloat(String(v == null ? '' : v).replace(/\s/g, '').replace(',', '.')) || 0; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function tpl(str, vals) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return vals[k] != null ? vals[k] : m; });
  }
  function band(lm) {
    if (lm < 10000) return [2.5, 4];
    if (lm < 17000) return [4, 6];
    if (lm < 26000) return [6, 8];
    if (lm < 34000) return [8, 10];
    return [10, 99];
  }
  function tierPct(tiers, n) {
    if (!tiers || !tiers.length) return 0;
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i], min = +t.min || 0, max = t.max == null ? Infinity : +t.max;
      if (n >= min && n <= max) return +t.pct || 0;
    }
    return 0;
  }

  function init(root) {
    if (root.getAttribute('data-tp-init')) return;
    var dataEl = root.querySelector('script[data-tp-data]');
    if (!dataEl) return;
    root.setAttribute('data-tp-init', '1');
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var L = cfg.labels || {};

    var loc = cfg.locale || document.documentElement.lang || 'nl-NL';
    var nfMoney, nfMoney0;
    try {
      nfMoney = new Intl.NumberFormat(loc, { style: 'currency', currency: cfg.currency || 'EUR' });
      nfMoney0 = new Intl.NumberFormat(loc, { style: 'currency', currency: cfg.currency || 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 });
    } catch (e) {
      loc = 'nl-NL';
      nfMoney = new Intl.NumberFormat(loc, { style: 'currency', currency: 'EUR' });
      nfMoney0 = new Intl.NumberFormat(loc, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 });
    }
    function fmt(n, d) { return n.toLocaleString(loc, { minimumFractionDigits: d, maximumFractionDigits: d }); }

    // Productdata omzetten naar getallen
    var prods = [];
    (cfg.products || []).forEach(function (p) {
      var lm = intOf(p.lm), w = intOf(p.w);
      if (!lm || !w || !p.v || !p.v.length) return;
      var colorIdx = -1;
      for (var i = 0; i < 3 && colorIdx < 0; i++) {
        for (var j = 0; j < p.v.length; j++) {
          if (p.v[j].o && /\b\d{4}\s?K\b/i.test(p.v[j].o[i] || '')) { colorIdx = i; break; }
        }
      }
      var drvIdx = -1;
      for (var d = 0; d < 3 && drvIdx < 0; d++) {
        for (var e2 = 0; e2 < p.v.length; e2++) {
          if (p.v[e2].o && /DALI|[01]-10\s?V/i.test(p.v[e2].o[d] || '')) { drvIdx = d; break; }
        }
      }
      prods.push({
        id: p.id, title: p.t, url: p.u, img: p.img, lm: lm, w: w,
        eff: intOf(p.eff) || Math.round(lm / w), ang: intOf(p.ang) || 120, ra: intOf(p.ra),
        sens: !!p.sens, dali: !!p.dali, lin: !!p.lin, dim: p.dim || '', drv: p.drv || '',
        tiers: p.tiers || [], qmin: intOf(p.qmin), colorIdx: colorIdx, drvIdx: drvIdx, on: p.on || [], v: p.v
      });
    });

    function colorOf(p, v) { return p.colorIdx >= 0 && v.o ? (v.o[p.colorIdx] || '') : ''; }
    function stockOk(v, n) { return !v.tr || v.q >= n; }
    function drvOf(p, v) { return p.drvIdx >= 0 && v.o ? (v.o[p.drvIdx] || '') : ''; }
    // Voldoet deze variant aan de gekozen sturing?
    function reqOk(p, v, req) {
      if (req === 'dali') return /DALI/i.test(drvOf(p, v));
      if (req === 'dim') return p.drvIdx >= 0 || /^(ja|optioneel|yes|oui|s[ií])/i.test(p.dim);
      if (req === 'sens') return p.sens;
      return true;
    }
    function variantsFor(p, n, req) {
      var vs = p.v.filter(function (v) { return stockOk(v, n) && reqOk(p, v, req); });
      vs.sort(function (a, b) {
        if (a.p !== b.p) return a.p - b.p;
        var a4 = /4000\s?K/i.test(colorOf(p, a)) ? 0 : 1, b4 = /4000\s?K/i.test(colorOf(p, b)) ? 0 : 1;
        if (a4 !== b4) return a4 - b4;
        return (b.tr ? b.q : 1e9) - (a.tr ? a.q : 1e9);
      });
      return vs;
    }

    var els = {
      L: root.querySelector('[name="tp_l"]'), B: root.querySelector('[name="tp_b"]'), H: root.querySelector('[name="tp_h"]'),
      inr: root.querySelector('[name="tp_inr"]'), use: root.querySelector('[name="tp_use"]'), req: root.querySelector('[name="tp_req"]'),
      kwh: root.querySelector('[name="tp_kwh"]'), hrs: root.querySelector('[name="tp_hrs"]'),
      levels: root.querySelectorAll('[data-tp-level]'),
      res: root.querySelector('[data-tp-result]'), cards: root.querySelector('[data-tp-cards]')
    };
    var level = 'norm';
    if (els.use && cfg.defaultUse) {
      for (var o = 0; o < els.use.options.length; o++) {
        if (els.use.options[o].value === cfg.defaultUse) { els.use.value = cfg.defaultUse; break; }
      }
    }

    var current = { picks: [], summary: null };

    function calc() {
      var uses = cfg.uses || [];
      if (!uses.length) return;
      var u = uses[0];
      for (var i = 0; i < uses.length; i++) { if (uses[i].key === els.use.value) u = uses[i]; }
      var up = level === 'up';
      var lux = up ? u.up : u.lux;
      var f = els.inr && els.inr.value === 'stelling' ? 0.45 : 0.55;
      var req = els.req ? els.req.value : 'none';
      var Lm = dec(els.L.value), Bm = dec(els.B.value), Hm = dec(els.H.value);
      var kwh = dec(els.kwh ? els.kwh.value : cfg.kwh), hrs = dec(els.hrs ? els.hrs.value : cfg.hrs);
      var cands = [];
      var inputOk = Lm > 0 && Bm > 0 && Hm >= 2.5;

      if (inputOk) {
        var area = Lm * Bm;
        prods.forEach(function (p) {
          var bd = band(p.lm);
          if (Hm < bd[0] || Hm > bd[1]) return;
          if (p.ra < u.ra) return;
          var n = Math.max(1, Math.ceil(area * lux / (p.lm * f)));
          var sh = (u.uo <= 0.4 ? 1.5 : 1.2) - (p.ang <= 90 ? 0.2 : 0);
          if (Hm >= 10) sh = Math.min(sh, 1.2);
          var maxSp = sh * Hm;
          var minRows = Math.max(1, Math.ceil(Bm / maxSp)), minCols = Math.max(1, Math.ceil(Lm / maxSp));
          var rows = Math.max(minRows, Math.round(Math.sqrt(n * Bm / Lm)) || 1);
          var cols = Math.max(minCols, Math.ceil(n / rows));
          while ((rows - 1) * cols >= n && rows - 1 >= minRows) rows--;
          while (rows * (cols - 1) >= n && cols - 1 >= minCols) cols--;
          var t = rows * cols;
          var vs = variantsFor(p, t, req);
          if (!vs.length) return;
          var c = { p: p, vs: vs, req: req, rows: rows, cols: cols, t: t, watt: t * p.w, lux: t * p.lm * f / area, kwh: kwh, hrs: hrs };
          setVariant(c, vs[0]);
          cands.push(c);
        });
      }

      var picks = [];
      if (cands.length) {
        var used = function (c) { for (var y = 0; y < picks.length; y++) { if (picks[y].c === c) return true; } return false; };
        var first = function (arr, test) { for (var k = 0; k < arr.length; k++) { if (!used(arr[k]) && (!test || test(arr[k]))) return arr[k]; } return null; };
        var byTco = cands.slice().sort(function (a, b) { return a.tco - b.tco; });
        var byCost = cands.slice().sort(function (a, b) { return a.cost - b.cost || a.tco - b.tco; });
        var byQty = cands.slice().sort(function (a, b) { return a.t - b.t || a.tco - b.tco; });
        // Een badge alleen tonen als hij klopt. Is de beste keuze over 5 jaar ook de goedkoopste, dan krijgt die kaart beide.
        var best = byTco[0], both = byCost[0] === best, hasTco2 = false;
        picks.push({ c: best, key: both ? 'both' : 'tco', top: true });
        if (!both) picks.push({ c: byCost[0], key: 'cost' });
        var c3 = first(byQty, function (c) { return c.t < best.t; });
        if (c3) picks.push({ c: c3, key: 'qty' });
        else { c3 = first(byTco); if (c3) { picks.push({ c: c3, key: 'tco2' }); hasTco2 = true; } }
        if (both) { var cx = first(byTco); if (cx) { picks.push({ c: cx, key: hasTco2 ? 'alt' : 'tco2' }); } }
        var k4 = u.lin ? 'lin' : 'sens';
        var c4 = first(byTco, function (c) { return u.lin ? c.p.lin : c.p.sens; });
        if (!c4) { c4 = first(byTco, function (c) { return c.p.sens; }); k4 = 'sens'; }
        if (!c4) { c4 = first(byTco, function (c) { return c.p.dali; }); k4 = 'dali'; }
        if (!c4) { c4 = first(byTco); k4 = 'alt'; }
        if ((k4 === 'sens' && req === 'sens') || (k4 === 'dali' && req === 'dali')) k4 = 'alt';
        if (c4) picks.push({ c: c4, key: k4 });
      }

      current.picks = picks;
      current.summary = { u: u, req: req, lux: lux, up: up, inr: els.inr ? els.inr.value : 'open', area: Lm * Bm, H: Hm, Lm: Lm, Bm: Bm };
      renderResult(inputOk);
      renderCards();
    }

    function setVariant(c, v) {
      c.v = v;
      c.unit = v.p / 100;
      c.pct = tierPct(c.p.tiers, c.t);
      c.unitNet = c.unit * (1 - c.pct / 100);
      c.cost = c.t * c.unitNet;
      c.energy = c.watt / 1000 * c.hrs * c.kwh;
      c.tco = c.cost + 5 * c.energy;
    }

    function renderResult(inputOk) {
      var s = current.summary;
      if (!current.picks.length) {
        els.res.innerHTML = '<div class="tp-res tp-res--empty"><p class="tp-res__big">' + esc(L.empty_title) + '</p><p>' +
          esc(inputOk ? L.empty_nomatch : L.empty_text) + '</p></div>';
        return;
      }
      var b = current.picks[0].c;
      var head = tpl(L.res_head, { m2: fmt(s.area, 0), lux: s.lux }) + (s.up ? ' ' + (L.res_up || '') : '');
      var html = '<div class="tp-res">' +
        '<p class="tp-res__head">' + esc(head) + '</p>' +
        '<p class="tp-res__big">' + esc(tpl(L.res_title, { qty: b.t, lm: fmt(b.p.lm, 0) })) + '</p>' +
        '<p class="tp-res__model">' + esc(b.p.title) + '</p>' +
        '<p>' + esc(tpl(L.res_grid, { grid: b.cols + ' × ' + b.rows, spacing: fmt(s.Lm / b.cols, 1) + ' × ' + fmt(s.Bm / b.rows, 1) })) + '</p>' +
        '<p>' + esc(tpl(L.res_lux, { lux: fmt(b.lux, 0), kw: fmt(b.watt / 1000, 2) })) + '</p>';
      if (b.lux > s.lux * 1.5 && L.res_dim) html += '<p class="tp-res__note">' + esc(L.res_dim) + '</p>';
      html += '<div class="tp-res__actions">' +
        '<a class="tp-btn tp-btn--primary" href="#tp-producten">' + esc(L.btn_compare) + '</a>' +
        '<a class="tp-btn tp-btn--outline" href="' + esc(quoteHref(b)) + '" data-tp-event="klik_offerte" data-tp-plek="rekenhulp">' + esc(L.btn_quote) + '</a>' +
        '</div></div>';
      els.res.innerHTML = html;
    }

    function quoteHref(c) {
      var base = cfg.quoteUrl || '/';
      return base + (base.indexOf('?') > -1 ? '&' : '?') + 'aantal=' + c.t + '&product=' + encodeURIComponent(c.p.title);
    }

    var badgeKey = { both: 'b_both', tco: 'b_tco', cost: 'b_cost', qty: 'b_qty', tco2: 'b_tco2', lin: 'b_lin', sens: 'b_sens', dali: 'b_dali', alt: 'b_alt' };

    function specLine(p, v) {
      var bits = [p.w + 'W', p.eff + ' lm/W', p.ang + '°'];
      if (p.ra) bits.push('Ra ' + p.ra + '+');
      if (p.drv) bits.push(p.drv);
      if (p.sens) bits.push(L.f_sens);
      else if (drvOf(p, v)) bits.push(drvOf(p, v));
      else if (/^(ja|yes|oui|s[ií])$/i.test(p.dim)) bits.push(L.f_dim);
      return bits.filter(Boolean).join(' · ');
    }

    // Keuzemenu's op de kaart: lichtkleur en uitvoering (zoals montage). De driver volgt uit het veld Sturing.
    function optionsHtml(c) {
      var p = c.p, h = '';
      for (var i = 0; i < 3; i++) {
        if (i === p.drvIdx) continue;
        var vals = [], seen = {};
        p.v.forEach(function (v) { var x = v.o && v.o[i]; if (x && !seen[x]) { seen[x] = 1; vals.push(x); } });
        if (!vals.length || vals[0] === 'Default Title') continue;
        if (vals.length === 1 && i !== p.colorIdx) continue;
        var name = (p.on && p.on[i]) || (i === p.colorIdx ? L.c_color : '');
        h += '<label class="tp-card__color">' + esc(name) + '<select data-tp-opt>';
        vals.forEach(function (val) {
          var cand = null;
          for (var k = 0; k < p.v.length && !cand; k++) {
            var v = p.v[k], match = v.o[i] === val;
            for (var j = 0; j < 3 && match; j++) { if (j !== i && (v.o[j] || '') !== (c.v.o[j] || '')) match = false; }
            if (match) cand = v;
          }
          var ok = cand && stockOk(cand, c.t) && reqOk(p, cand, c.req);
          h += '<option value="' + (cand ? cand.id : '') + '"' + (cand && cand.id === c.v.id ? ' selected' : '') + (ok ? '' : ' disabled') + '>' +
            esc(val) + (ok ? '' : ' (' + esc(L.c_oos || 'niet op voorraad') + ')') + '</option>';
        });
        h += '</select></label>';
      }
      return h;
    }

    function cardHtml(o, idx) {
      var c = o.c, p = c.p, bk = badgeKey[o.key];
      var h = '<article class="tp-card' + (o.top ? ' tp-card--top' : '') + '" data-idx="' + idx + '">';
      h += '<div class="tp-card__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="360" height="360" loading="lazy">' : '') + '</div>';
      var badge = L[bk] || (o.key === 'both' ? 'Beste keuze en laagste prijs' : '');
      var why = L[bk + '_why'] || (o.key === 'both' ? 'Laagste aanschafprijs en ook de laagste kosten over 5 jaar.' : '');
      h += '<div><p class="tp-card__badge">' + esc(badge) + '</p><p class="tp-card__why">' + esc(why) + '</p></div>';
      h += '<p class="tp-card__lm">' + esc(tpl(L.c_lm || '[lm] lumen', { lm: fmt(p.lm, 0) })) + '</p>';
      h += '<h3 class="tp-card__name">' + esc(p.title) + '</h3>';
      h += '<p class="tp-card__spec">' + esc(specLine(p, c.v)) + '</p>';
      h += optionsHtml(c);
      h += '<dl class="tp-card__dl">' +
        '<dt>' + esc(L.c_qty) + '</dt><dd>' + c.t + ' ' + esc(L.c_pcs) + '</dd>' +
        '<dt>' + esc(L.c_cost) + '</dt><dd>' + esc(nfMoney0.format(Math.round(c.cost))) + '</dd>' +
        '<dt>' + esc(L.c_energy) + '</dt><dd>' + esc(nfMoney0.format(Math.round(c.energy))) + '</dd>' +
        '<dt class="tp-card__tot">' + esc(L.c_tco) + '</dt><dd class="tp-card__tot">' + esc(nfMoney0.format(Math.round(c.tco))) + '</dd>' +
        '</dl>';
      if (c.pct > 0) {
        h += '<p class="tp-card__price"><s>' + esc(nfMoney.format(c.unit)) + '</s> <strong>' + esc(tpl(L.c_unit, { price: nfMoney.format(c.unitNet) })) + '</strong></p>';
        h += '<p class="tp-card__staffel">' + esc(tpl(L.c_staffel, { price: nfMoney.format(c.unitNet), pct: c.pct })) + '</p>';
      } else {
        h += '<p class="tp-card__price"><strong>' + esc(tpl(L.c_unit, { price: nfMoney.format(c.unit) })) + '</strong></p>';
      }
      if (p.qmin && c.t >= p.qmin && L.c_project) {
        h += '<a class="tp-card__project" href="' + esc(quoteHref(c)) + '" data-tp-event="klik_offerte" data-tp-plek="kaart">' + esc(tpl(L.c_project, { qty: p.qmin })) + '</a>';
      }
      h += '<button type="button" class="tp-btn tp-btn--primary tp-card__cart" data-tp-cart>' + esc(tpl(L.c_cart, { qty: c.t })) + '</button>';
      h += '<p class="tp-card__msg" role="status" aria-live="polite"></p>';
      h += '<a class="tp-card__info" href="' + esc(p.url) + '" data-tp-datasheet>' + esc(L.c_info) + '</a>';
      h += '</article>';
      return h;
    }

    function renderCards() {
      if (!els.cards) return;
      if (!current.picks.length) { els.cards.innerHTML = ''; els.cards.hidden = true; return; }
      els.cards.hidden = false;
      els.cards.innerHTML = current.picks.map(cardHtml).join('');
    }

    function rerenderCard(idx) {
      var art = els.cards.querySelector('.tp-card[data-idx="' + idx + '"]');
      if (!art) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = cardHtml(current.picks[idx], idx);
      art.parentNode.replaceChild(tmp.firstChild, art);
    }

    // Winkelwagen
    function addToCart(idx, btn) {
      var o = current.picks[idx]; if (!o) return;
      var c = o.c, msg = btn.parentNode.querySelector('.tp-card__msg');
      btn.disabled = true;
      window.tpTrack('klik_winkelwagen', { tp_kaart: o.key, tp_product: c.p.title, tp_variant: c.v.id, tp_aantal: c.t });
      var url = String(cfg.cartAdd || '/cart/add').replace(/\/$/, '') + '.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: c.v.id, quantity: c.t }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        btn.disabled = false;
        if (msg) msg.textContent = L.c_added || '';
        if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: btn } }));
        } else {
          location.href = cfg.cartUrl || '/cart';
        }
      }).catch(function () {
        btn.disabled = false;
        if (msg) msg.textContent = L.c_error || '';
      });
    }

    // Meten
    var started = false, resultTimer = null;
    function userChanged() {
      if (!started) { started = true; window.tpTrack('rekenhulp_start', { tp_pagina: location.pathname }); }
      clearTimeout(resultTimer);
      resultTimer = setTimeout(function () {
        var s = current.summary, b = current.picks[0];
        window.tpTrack('rekenhulp_result', {
          tp_gebruik: s.u.key, tp_sturing: s.req, tp_lux: s.lux, tp_niveau: s.up ? 'verhoogd' : 'minimaal', tp_inrichting: s.inr,
          tp_m2: Math.round(s.area), tp_hoogte: s.H,
          tp_advies: b ? b.c.t + ' x ' + b.c.p.lm + ' lm' : 'geen'
        });
      }, 1500);
    }

    var debounce = null;
    function onInput() { clearTimeout(debounce); debounce = setTimeout(function () { calc(); userChanged(); }, 250); }
    [els.L, els.B, els.H, els.kwh, els.hrs].forEach(function (el) { if (el) { el.addEventListener('input', onInput); el.addEventListener('change', onInput); } });
    [els.inr, els.use, els.req].forEach(function (el) { if (el) el.addEventListener('change', function () { calc(); userChanged(); }); });
    Array.prototype.forEach.call(els.levels, function (btn) {
      btn.addEventListener('click', function () {
        level = btn.getAttribute('data-tp-level');
        Array.prototype.forEach.call(els.levels, function (b2) { b2.setAttribute('aria-pressed', b2 === btn ? 'true' : 'false'); });
        calc(); userChanged();
      });
    });
    if (els.cards) {
      els.cards.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tp-cart]');
        if (btn) { addToCart(+btn.closest('.tp-card').getAttribute('data-idx'), btn); return; }
        var ds = e.target.closest('[data-tp-datasheet]');
        if (ds) { var o = current.picks[+ds.closest('.tp-card').getAttribute('data-idx')]; window.tpTrack('klik_datasheet', { tp_product: o ? o.c.p.title : '' }); }
      });
      els.cards.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-tp-opt]'); if (!sel || !sel.value) return;
        var idx = +sel.closest('.tp-card').getAttribute('data-idx'), o = current.picks[idx];
        for (var i = 0; i < o.c.p.v.length; i++) { if (String(o.c.p.v[i].id) === sel.value) { setVariant(o.c, o.c.p.v[i]); break; } }
        rerenderCard(idx);
      });
    }

    // Inhoudsopgave: ids op de H2's in de paginatekst zetten
    var h2s = document.querySelectorAll('.page__content h2');
    Array.prototype.forEach.call(root.querySelectorAll('[data-tp-toc]'), function (a) {
      var h = h2s[+a.getAttribute('data-tp-toc')], id = (a.getAttribute('href') || '').slice(1);
      if (h && id && !h.id) h.id = id;
    });

    calc();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-tp-rekenhulp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();